export default __webpack_public_path__ + "locales/cs/EmbeddingPanel.json?hash=6c64df6b70dcc6c00cd969167ebe6d67";